/* see docs/EXTRACTED_COMMENTS.md#c057 */

import {
  InlineClassPicker,
  type PickerEntry,
  type PickerVariant,
} from "./InlineClassPicker"
import { toRgb } from "./colorUtils"
import { renderCustomColorControl } from "./customColorControl"
import type { BackgroundOption } from "./types"
import type { API } from "@editorjs/editorjs"

export class BackgroundPickerTool extends InlineClassPicker {
  static title = "Highlight colour"

  private backgrounds: BackgroundOption[]

  constructor({
    api,
    config,
  }: {
    api: API
    config?: { backgrounds?: BackgroundOption[] }
  }) {
    super({ api })
    this.backgrounds = config?.backgrounds ?? []
  }

  protected get pickerTitle(): string {
    return "Highlight colour"
  }

  protected get variant(): PickerVariant {
    return "swatch"
  }

  protected get colorProperty(): "backgroundColor" {
    return "backgroundColor"
  }

  protected get icon(): string {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.5" y="7.5" width="17" height="10" rx="2.5" fill="currentColor" opacity="0.22"/>
      <text x="12" y="15.5" text-anchor="middle" font-family="Georgia, 'Times New Roman', serif"
        font-size="13" font-weight="700" fill="currentColor">A</text>
      <rect x="5" y="19.5" width="14" height="2.6" rx="1.3" fill="currentColor"/>
    </svg>`
  }

  protected get entries(): PickerEntry[] {
    const clear: PickerEntry = {
      label: "None",
      className: "",
      style: { backgroundColor: "transparent" },
      clear: true,
    }
    return [
      clear,
      ...this.backgrounds.map(background => {
        const rgb =
          toRgb(background.backgroundColor) ?? background.backgroundColor
        return {
          label: background.label,
          className: background.className,
          style: { backgroundColor: rgb },
          swatch: rgb,
        }
      }),
    ]
  }

  protected renderFreeControl(): HTMLElement {
    return renderCustomColorControl({
      initial: "#fde68a",
      onPreview: rgb =>
        this.previewEntry({
          label: rgb,
          className: "",
          style: { backgroundColor: rgb },
        }),
      onCommit: rgb =>
        this.applyEntry({
          label: rgb,
          className: "",
          style: { backgroundColor: rgb },
        }),
    })
  }
}
